import { Images } from '@/assets/images/Images';

export class PRODUCTS_DATA_API {
    constructor(data) {
        this.id = data.id || data.productId || '';
        this.name = data.name || 'Sin nombre';
        this.description = data.description || '';
        this.price = data.price || 0;
        this.rating = data.rating || 0;
        this.image = data.image_url || data.image || 'https://via.placeholder.com/300';
        this.categoryId = data.categoryId || data.category || 'all';
        this.likes_count = data.likes_count || 0;
    }
}

export const PRODUCTS_DATA_LOCAL = [
    {
        id: 22123227372,
        name: "Milkshake de Chocolate",
        price: "120000",
        rating: "4.5",
        image: Images.shakeChoco,
        category: "ice-cream",
        description: "Cremoso chocolate belga con salsa artesanal.",
        reviews: 128
    },
    {
        id: 127372,
        name: "Milkshake de Fresa",
        price: "13000",
        rating: "3.5",
        image: Images.shakeFresa,
        category: "ice-cream",
        description: "Fresas naturales con un toque de vainilla.",
        reviews: 85
    },
    {
        id: 1273724,
        name: "Ab",
        price: "1000",
        rating: "3.5",
        image: Images.shakeFresa,
        category: "desserts",
        description: "Ab.",
        reviews: 85
    }
];